import { createContext, useContext } from "react";

export const BookingContext = createContext({
  booking: {},
  setBooking: () => {},
});
export const useBookingContext = () => useContext(BookingContext);
